import { ref } from "vue";
  import * as utils from "@/utils/index";
  export default () => {
    const languageList = ["en-US"];
    const pageInfo = {"default":{"title":"","ico":""},"en-US":{"title":"Classic Dark Fantasy MMORPG!","ico":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726230737051-2.png"}};

    const languageTxt = {"en-US":{"area":"Region","inputPhone":"Insert mobile phone number","inputCheckCode":"Verification code","getCheckCode":"Get Code","agreeItem":"Agree to terms","selectArea":"Select region","phoneError":"Please in","agreeItemFirst":"Please agree to terms of service first","checkCodeSendSucc":"Code sent","reserveSucc":"Pre-registered!","-254":"Your number has been reserved","-1005":"Activity has not started yet","-1006":"The event is over","-1004":"please log in first","-18020":"system error","-18013":"Daily limit reached","-18012":"Multiple codes have been sent","-18010":"Telecom carrier error","-18003":"Parameter error","-18002":"Verification code invalid or expired","-18001":"Failed to send verification code. Attempt limit reached","-251":"Your account has been involved in the event","-18011":"Invalid form of number","tw":"Taiwan China","hk":"Hong Kong SAR China","mo":"Macau SAR China","ma":"Malaysia","zh":"Mainland China","vi":"Vietnam","ja":"Japan","th":"Thailand","ie":"Indonesia","ph":"Philippines","sg":"Singapore","ko":"South Korea","other":"Other","termText":"I have accepted {mainHost} [Terms of Use] and [Privacy Policy]","fwtk":"TERMS OF SERVICE","yszc":"PRIVACY POLICY","zzf":"","sqf":""},"default":{"area":"","inputPhone":"","inputCheckCode":"","getCheckCode":"","agreeItem":"","selectArea":"","phoneError":"","agreeItemFirst":"","checkCodeSendSucc":"","reserveSucc":"","-254":"","-1005":"","-1006":"","-1004":"","-18020":"","-18013":"","-18012":"","-18010":"","-18003":"","-18002":"","-18001":"","-251":"","-18011":"","tw":"","hk":"","mo":"","ma":"","zh":"","vi":"","ja":"","th":"","ie":"","ph":"","sg":"","ko":"","other":"","termText":"","fwtk":"","yszc":"","zzf":"","sqf":""}};
  
    const getSystemLanguage =  ()=>{
      let res = navigator.language || navigator.userLanguage || navigator.browerLanguage || navigator.systemLanguage;
      if (res.indexOf("-") > -1) {
        const langArr = res.split("-");
        res = langArr[0] === "zh" ? langArr[1] : langArr[0];
      }
      return res.toLowerCase();
    };
    const checkLanguage =  (lang) =>{
      let res = "";
      if (lang) {
        if (lang.indexOf("-") > -1) {
          for (let i = 0; i < languageList.length; i++) {
            if (languageList[i] === lang) {
              res = languageList[i];
            }
          }
        } else {
          const reg = new RegExp(lang, "g");
          for (let i = 0; i < languageList.length; i++) {
            if (reg.test(languageList[i].toLowerCase())) {
              res = languageList[i];
            }
          }
        }
      }
      return res;
    };
    let curLang = checkLanguage(utils.getUrlParams("appLanguage")) || checkLanguage(utils.getUrlParams("language")) || checkLanguage(getSystemLanguage()) || checkLanguage("en-US") || "default";
    const initLang = () => {
      document.body.className += " " + curLang;
      document.getElementsByTagName("html")[0].setAttribute("dir", curLang == "ar-SA" ? "rtl" : "ltr");
      
      if(!pageInfo[curLang]) return;
      if(pageInfo[curLang].title){
        document.title = pageInfo[curLang].title;
      }
      if(pageInfo[curLang].ico){
        try{
          document.getElementById("icon").setAttribute("href", pageInfo[curLang].ico);
          document.getElementById("shortcut").setAttribute("href", pageInfo[curLang].ico);
        }catch(e){}
      }
    };

    const getLangTxt = (key,msg)=>{
      let info = languageTxt[curLang] || languageTxt.default;
      return info[key] || String(msg);
    }
  
    return { curLang, initLang, getLangTxt, langData:languageTxt[curLang]||{} };
  };
  